import { DocumentSearchResultStatus } from '@/dc-shared-web/src/hooks/api/document/types'

type GetUploadVersionDisabledState = (args: {
  status: DocumentSearchResultStatus
  versionsLength: number
  hasPlaybook: boolean
}) => { disabled: boolean; tooltip: string | undefined }

export const getUploadVersionDisabledState: GetUploadVersionDisabledState = ({
  status,
  versionsLength,
  hasPlaybook,
}) => {
  if (status !== 'completed') {
    return {
      disabled: true,
      tooltip: 'Please wait until this crunch finishes processing',
    }
  }

  if (versionsLength > 0) {
    return {
      disabled: true,
      tooltip: 'A different version of this document was already uploaded',
    }
  }

  if (hasPlaybook) {
    return {
      disabled: true,
      tooltip: "This crunch doesn't support version comparisons",
    }
  }

  return {
    disabled: false,
    tooltip: undefined,
  }
}
